import { render, staticRenderFns } from "./AccordionSection.vue?vue&type=template&id=738b6275&scoped=true&"
import script from "./AccordionSection.vue?vue&type=script&lang=ts&"
export * from "./AccordionSection.vue?vue&type=script&lang=ts&"
import style0 from "./AccordionSection.vue?vue&type=style&index=0&id=738b6275&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738b6275",
  null
  
)

export default component.exports